import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "detail_container"
}
const _hoisted_2 = { class: "detail_base-info card-white-6" }
const _hoisted_3 = { class: "detail_header" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_6 = { key: 1 }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("保存")
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "hw_detail_table_container card-white-6" }
const _hoisted_11 = { class: "hw_detail_table_header" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "title" }, "账号列表", -1)
const _hoisted_13 = { key: 0 }
const _hoisted_14 = /*#__PURE__*/_createTextVNode("录入账户")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("批量编辑")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_18 = {
  key: 0,
  class: "card-white-6 hw_detail_table_container"
}

import { edit_opa_apply_info, get_opa_apply_item } from '@/api/ugs-openAccount';
  import { DialogConfig, DialogFormItem } from '@/components/WeDialog/types';
  import { BasicColumn, useTable } from '@/components/WeTable';
  import { useApp } from '@/hooks/useApp';
  import { appStore } from '@/store/modules/app';
  import { copyObjectToReactive, isEmptyData, downloadByUrl, getValueById, getTextFromValue } from '@/utils/common';
  import { required } from '@/utils/validate';
  import { computed, reactive, ref, unref } from 'vue';
  import WeOssUpload from '@/components/WeUpload/OssUpload.vue';
  import { useOptionList } from '@/hooks/useOptionList';
  import { omit, pick, pickBy } from 'lodash-es';
  import { edit_ml_accounts, get_ml_account_apply_contract_list, upload_ml_accounts } from '@/api/common-cms';
  import { get_account_page } from '@/api/common-cms';
  import { commonStore } from '@/store/modules/commonLists';
  import { useJump } from '@/hooks/useJump';
  import { get_product_list } from '@/api/more';
  import { useUser } from '@/hooks/useUser';

  
export default /*#__PURE__*/_defineComponent({
  props: {
    id: { default: -1 }
  },
  setup(__props: any) {

const props = __props as { id: string | number }

   // TAB.WAITING
  const demand_contract_items = ref<Recordable[]>([]);
  const supply_contract_items = ref<Recordable[]>([]);
  const columns = computed<BasicColumn[]>(() => {
    const basic_columns: Recordable[] = [
      {
        title: '账户ID',
        dataIndex: 'account_id',
      },
      {
        title: '账户名称',
        dataIndex: 'account_name',
      },
      {
        title: '业务类型',
        dataIndex: 'rd_account_logic_name',
      },
      // {
      //   title: '产品Code',
      //   dataIndex: 'product__code',
      // },
      {
        title: 'Supply合同',
        dataIndex: 'rd_supply_contract_name',
      },
      {
        title: 'Demand合同',
        dataIndex: 'rd_demand_contract_name',
      },
      // {
      //   title: '优化师',
      //   dataIndex: 'rd_ua_name',
      // },
      {
        title: '创建人',
        dataIndex: 'rd_creator_name',
      },
    ];
    if (is_tiktok.value) {
      return [
        ...basic_columns,
        {
          title: '操作',
          dataIndex: 'action',
          flag: 'ACTION',
          slots: {
            customRender: 'action',
          },
        },
      ];
    }
    return [
      ...basic_columns,
      {
        title: '广告类型',
        dataIndex: 'ad_type',
      },
      {
        title: 'MCC账号',
        dataIndex: 'mcc_account_name',
        ignoreField: true,
      },
      {
        title: '操作',
        dataIndex: 'action',
        flag: 'ACTION',
        slots: {
          customRender: 'action',
        },
      },
    ];
  });
  // const form_attrs = computed(() => {
  //   if (editMode.value) {
  //     return {
  //       labelCol: "{ style: 'width: 180px' }",
  //       wrapperCol: "{ style: 'max-width: calc(100% - 180px)' }",
  //       labelAlign: 'right',
  //     };
  //   }
  //   return {
  //     labelAlign: 'left',
  //   };
  // });
  const product_items = ref<Recordable[]>([]);
  const product_list = ref<Recordable[]>([]);
  const is_inner = computed(() => {
    return !isEmptyData(detail_data.value) && detail_data.value.rd_source === '开户平台内部版';
  });
  const { $showDialog, $message, $showAlert } = useApp();
  const { isGod } = useUser();
  const { jumpToCompany, jumpToOpenAccountRechargeDetail } = useJump();
  const [register, { getSelectRows, clearSelectedRowKeys, reload }] = useTable({
    title: '账号列表',
    columns,
    rowSelection: { type: 'checkbox' },
    showTableHeader: false,
    useSearchForm: false,
    api: (params) => {
      params.opa_apply_id = props.id;
      params.fields.push('demand_contract_id');
      params.fields.push('supply_contract_id');
      params.fields.push('id');
      params.fields.push('account_logic');
      params.fields.push('ua_id');
      if (is_google.value) {
        params.fields.push('account_config');
      }
      params.show_in = 'apply';
      return get_account_page(params);
    },
  });
  const detail_data = ref<Recordable>({});
  const editMode = ref(false);
  const regions = ref([
    { id: 0, name: '大陆' },
    { id: 1, name: '港澳台' },
    { id: 2, name: '海外' },
  ]);
  const { get_ml_business, get_mcc_account_list, get_ml_delivery_method } = useOptionList();
  const detail_data_edit = reactive<Recordable>({
    company_name: '',
    bussiness_center_id: '',
    region_type: '',
    company_code: '',
    contact_email: '',
    contact_title: '',
    contact_phone: '',
    account_count: '',
    account_name: '',
    account_timezone: '',
    app_url: '',
    download_url: '',
    delivery_area: '',
    delivery_method: '',
    note: '',
    upload_file: {
      filename: '',
      url: '',
    },
    products: [],
    product_id: '',
    port_type: '',
  });
  const account_list = computed(() => {
    return [];
  });
  const edit_account = (record) => {
    const ml_business_items = ref([
      {
        id: 3001,
        name: '发行',
      },
      {
        id: 3002,
        name: '自研',
      },
      {
        id: 4001,
        name: 'ReSeller',
      },
      {
        id: 3004,
        name: 'MediaBy',
      },
    ]);
    const inputs: DialogFormItem[] = [
      {
        result: 'account_id',
        type: 'text',
        label: '账号ID',
        rules: [required()],
        width: 24,
      },
      {
        result: 'account_logic',
        type: 'select',
        label: '业务类型',
        rules: [required()],
        items: ml_business_items,
        width: 24,
      },
      // {
      //   result: 'ua_id',
      //   type: 'select',
      //   label: '优化师',
      //   rules: [required()],
      //   items: get_chiefs.value,
      //   width: 24,
      //   show: (result) => result.account_logic === 3004,
      // },
      // {
      //   result: 'product__code',
      //   type: 'select',
      //   label: '产品Code',
      //   rules: [required()],
      //   items: product_items.value,
      //   width: 24,
      //   show: (result) => result.account_logic === 3004,
      // },
      {
        result: 'supply_contract_id',
        type: 'select',
        label: 'Supply合同',
        rules: [required()],
        items: supply_contract_items.value,
        width: 24,
      },
      {
        result: 'demand_contract_id',
        type: 'select',
        label: 'Demand合同',
        rules: [required()],
        items: demand_contract_items.value,
        width: 24,
      },
    ];
    if (is_google.value) {
      inputs.push({
        result: 'ad_type',
        type: 'select',
        label: '广告类型',
        items: [
          { id: 'ac', name: 'AC' },
          { id: 'nonac', name: 'NonAC' },
        ],
        rules: [required()],
        width: 24,
      });
      inputs.push({
        result: 'mcc_account_id',
        type: 'select',
        label: 'MCC账号',
        rules: [required()],
        items: get_mcc_account_list,
        width: 24,
      });
    }
    const dialog: DialogConfig = {
      title: '编辑',
      labelCol: '110px',
      init: record,
      blocks: [{ type: 'input', value: inputs }],
      callback: (result) => {
        const accounts = [
          {
            ...pickBy(result, (value) => !isEmptyData(value)),
            ...{ id: record.id },
          },
        ];
        edit_ml_accounts({ accounts })
          .then(() => {
            $message.success('编辑成功');
          })
          .catch(() => {
            $message.error('编辑失败');
          })
          .finally(() => {
            appStore.SET_WE_DIALOG(null);
            reload();
          });
      },
    };
    $showDialog(dialog);
  };
  const edit_accounts = (type) => {
    const is_add = type === 'add';
    const ids = getSelectRows().map((item) => item.id);
    if (!is_add) {
      if (isEmptyData(ids)) {
        $message.error('请至少选择一条数据');
        return;
      }
    }
    const title = is_add ? '录入账户' : '批量编辑账户';
    let supply_contract_list: Recordable[] = [];
    supply_contract_list = supply_contract_items.value;
    // if (is_tiktok.value) {
    //   supply_contract_list = supply_contract_items.value.filter((item) => item.id === 1403);
    // } else if (is_google.value) {
    //   supply_contract_list = supply_contract_items.value.filter((item) => [4591, 1118].includes(item.id));
    // }
    const inputs: DialogFormItem[] = [
      {
        result: 'business_type',
        type: 'select',
        label: '业务类型',
        rules: is_add ? [required()] : [],
        items: get_ml_business.value.filter((item) => [1, 2, 3].includes(item.id as number)),
        width: 24,
      },
      // {
      //   result: 'ua_email',
      //   type: 'select',
      //   label: '优化师',
      //   rules: is_add ? [required()] : [],
      //   items: get_chiefs.value.map((item) => ({ id: item.email, name: item.name })),
      //   width: 24,
      //   show: (result) => !is_add || result.business_type === 2,
      // },
      // {
      //   result: 'product_code',
      //   type: 'select',
      //   label: '产品Code',
      //   rules: is_add ? [required()] : [],
      //   items: product_items.value,
      //   width: 24,
      //   show: (result) => !is_add || result.business_type === 2,
      // },
      {
        result: 'supply_contract_id',
        type: 'select',
        label: 'Supply合同',
        rules: is_add ? [required()] : [],
        items: supply_contract_list,
        init: supply_contract_list.length === 1 ? supply_contract_list[0].id : undefined,
        width: 24,
      },
      {
        result: 'demand_contract_id',
        type: 'select',
        label: 'Demand合同',
        rules: is_add ? [required()] : [],
        items: demand_contract_items.value,
        init: demand_contract_items.value.length === 1 ? demand_contract_items.value[0].id : undefined,
        width: 24,
      },
    ];
    if (is_google.value) {
      inputs.push({
        result: 'ad_type',
        type: 'select',
        label: '广告类型',
        items: [
          { id: 'ac', name: 'AC' },
          { id: 'nonac', name: 'NonAC' },
        ],
        rules: [required()],
        width: 24,
      });
      inputs.push({
        result: 'mcc_account_id',
        type: 'select',
        label: 'MCC账号',
        rules: [required()],
        items: get_mcc_account_list,
        width: 24,
      });
    }
    const dialog: DialogConfig = {
      title,
      labelCol: '110px',
      blocks: [
        { type: 'input', value: inputs },
        {
          type: 'note',
          label: '账户ID与名称',
          rules: [required()],
          result: 'account_ids',
          width: 24,
          autoSize: { minRows: 6 },
          placeholder: `请按照 “ID” [空格] “名称"的格式填写账号ID和账号名称，如有多个，请换行填写`,
          show: () => is_add,
        },
      ],
      callback: (result) => {
        const product_id = detail_data.value.product_id;
        let accounts: Recordable[] = [];
        if (is_add) {
          accounts = result.account_ids
            .split('\n')
            .map((item) => {
              const params: Recordable = {
                ...omit(result, ['account_ids']),
                account_id: item.split(' ')[0],
                account_name: item.split(' ')[1],
              };
              if (product_id) {
                params.product_code = product_items.value.find((f) => f.product_id === product_id)!.id;
              }
              return params;
            })
            .filter((f) => !isEmptyData(f.account_id));
          const params: Recordable = {
            platform: detail_data.value.platform,
            opa_apply_id: props.id,
            accounts,
            is_add: true,
          };
          upload_ml_accounts(params)
            .then((res) => {
              appStore.SET_WE_DIALOG(null);
              if (res.length > 0) {
                let showMsg = '';
                res.forEach((item) => {
                  showMsg += `<span style="display: block; width: max-content; text-align: right; margin-right: 5px;">${JSON.stringify(
                    item
                  )}</span>`;
                });
                $showAlert('添加失败', showMsg);
              } else {
                $message.success('添加成功');
                init_data();
                reload();
              }
            })
            .catch(() => {
              appStore.SET_WE_DIALOG(null);
              $message.error('添加失败');
            });
        } else {
          const arr = ids.map((item) => {
            const params = {
              id: item,
              ...result,
            };
            if (product_id) {
              params.product_code = product_items.value.find((f) => f.product_id === product_id)!.id;
            }
            return params;
          });
          edit_ml_accounts({ accounts: arr })
            .then(() => {
              $message.success('编辑成功');
            })
            .catch(() => {
              $message.error('编辑失败');
            })
            .finally(() => {
              appStore.SET_WE_DIALOG(null);
              clearSelectedRowKeys();
              reload();
            });
        }
      },
    };
    $showDialog(dialog);
  };
  const delete_account = (record) => {
    $showAlert('注意', '确定删除该数据吗', () => {
      const accounts = [
        {
          id: record.id,
          is_deleted: true,
        },
      ];
      edit_ml_accounts({ accounts })
        .then(() => {
          $message.success('删除成功');
          reload();
        })
        .catch(() => {
          $message.error('删除失败');
        })
        .finally(() => {
          appStore.SET_ALERT_CONFIG(null);
        });
    });
  };
  const init_data = () => {
    if (props.id === -1) {
      return;
    }
    commonStore.get_time_zone();
    get_opa_apply_item({ id: props.id }).then((res) => {
      detail_data.value = res;
      document.title = detail_data.value.name;
      initConfig();
      copyObjectToReactive(
        detail_data_edit,
        pick(unref(detail_data), [
          'id',
          'company_name',
          'bussiness_center_id',
          'region_type',
          'company_code',
          'contact_email',
          'contact_title',
          'contact_phone',
          'account_count',
          'account_name',
          'account_timezone',
          'app_url',
          'download_url',
          'delivery_area',
          'upload_file',
          'products',
          'company_code',
          'note',
          'product_id',
          'delivery_method',
          'port_type',
        ])
      );
    });
  };
  const initConfig = () => {
    commonStore.getMLModel();
    get_product_list({ get_all: true, pick_fields: ['id', 'name', 'code'] }).then((res) => {
      product_items.value = res.product_list
        .map((item) => ({
          id: item.code,
          name: `${item.code}-${item.name}`,
          product_id: item.id,
          product_name: item.name,
        }))
        .filter((item) => !isEmptyData(item.id));
      product_list.value = product_items.value.map((item) => ({
        id: item.product_id,
        name: item.name,
        product_name: item.product_name,
      }));
    });

    get_ml_account_apply_contract_list({ contract_type: 'demand', company_id: detail_data.value.company_id }).then(
      (res) => {
        demand_contract_items.value = res;
      }
    );
    get_ml_account_apply_contract_list({ contract_type: 'supply' }).then((res) => {
      supply_contract_items.value = res;
    });
  };
  const edit_data = () => {
    if (editMode.value === false) {
      editMode.value = true;
    } else {
      edit_opa_apply_info(unref(detail_data_edit))
        .then(() => {
          $message.success('编辑成功');
        })
        .catch(() => {
          $message.error('编辑失败');
        })
        .finally(() => {
          editMode.value = false;
          init_data();
        });
    }
  };
  const handle_product_code_change = (val) => {
    const find_item = product_list.value.find((item) => item.id === val)!;
    detail_data_edit.app_url = find_item.product_name;
    detail_data.value.app_url = find_item.product_name;
  };
  const handle_google_code_change = (val) => {
    const find_item = product_list.value.find((item) => item.id === val)!;
    detail_data_edit.products[0].app_url = find_item.product_name;
    detail_data.value.products[0].app_url = find_item.product_name;
  };
  const can_show_edit = computed(() => {
    return (
      !editMode.value &&
      !isEmptyData(detail_data.value) &&
      !isEmptyData(detail_data.value.flow) &&
      detail_data.value.flow.current_state_name === '媒体AM确认信息'
    );
  });
  const can_show_button = computed(() => {
    return (
      !isEmptyData(detail_data.value) &&
      !isEmptyData(detail_data.value.flow) &&
      detail_data.value.flow.current_state_name === '媒体AM开户'
    );
  });
  const is_tiktok = computed(() => {
    return detail_data.value.platform === 'TikTok';
  });
  const is_google = computed(() => {
    return detail_data.value.platform === 'Adwords';
  });
  const catchFlowFlag = async (flag, _) => {
    if (flag === 'FLAG_JUMP_TO_RECHARGE') {
      jumpToOpenAccountRechargeDetail({ id: detail_data.value.ugs_recharge_apply_id });
    }
  };
  init_data();

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_WeEditableWarp = _resolveComponent("WeEditableWarp")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_we_select = _resolveComponent("we-select")!
  const _component_a_input_number = _resolveComponent("a-input-number")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_we_table = _resolveComponent("we-table")!
  const _component_FlowTimeLine = _resolveComponent("FlowTimeLine")!
  const _component_page_detail_wrapper = _resolveComponent("page-detail-wrapper")!

  return (_openBlock(), _createBlock(_component_page_detail_wrapper, _mergeProps(_ctx.$attrs, {
    collapsed: true,
    title: detail_data.value.name
  }), {
    default: _withCtx(() => [
      (!_unref(isEmptyData)(detail_data.value))
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("span", _hoisted_4, _toDisplayString(`申请详情（媒体平台：${detail_data.value.platform}）`), 1),
                (_unref(can_show_edit))
                  ? (_openBlock(), _createBlock(_component_a_button, {
                      key: 0,
                      type: "primary",
                      onClick: edit_data
                    }, {
                      default: _withCtx(() => [
                        _hoisted_5
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (editMode.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
                      _createVNode(_component_a_button, {
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (editMode.value = false))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_7
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_button, {
                        type: "primary",
                        onClick: edit_data
                      }, {
                        default: _withCtx(() => [
                          _hoisted_8
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createVNode(_component_a_form, {
                model: _unref(detail_data_edit),
                ref: (_value, _refs) => {
                  _refs['detail_from_ref'] = _value
                }
              }, {
                default: _withCtx(() => [
                  (_unref(is_tiktok))
                    ? (_openBlock(), _createBlock(_component_a_row, {
                        key: 0,
                        gutter: 20,
                        type: "flex",
                        style: {"flex-wrap":"wrap"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_col, { span: 6 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_form_item, {
                                label: "来源",
                                name: "rd_source"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_WeEditableWarp, {
                                    value: detail_data.value.rd_source,
                                    edit: false
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_a_input, {
                                        value: _unref(detail_data_edit).rd_source,
                                        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_unref(detail_data_edit).rd_source) = $event))
                                      }, null, 8, ["value"])
                                    ]),
                                    _: 1
                                  }, 8, ["value"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_col, { span: 6 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_form_item, {
                                label: "客户简称",
                                name: "customer_name"
                              }, {
                                default: _withCtx(() => [
                                  (detail_data.value.company_id)
                                    ? (_openBlock(), _createBlock(_component_WeEditableWarp, {
                                        key: 0,
                                        value: detail_data.value.company.short_name,
                                        edit: false
                                      }, null, 8, ["value"]))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_col, { span: 12 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_form_item, {
                                label: "客户主体",
                                name: "customer_name"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_WeEditableWarp, {
                                    value: detail_data.value.customer_name,
                                    edit: false
                                  }, {
                                    text: _withCtx(() => [
                                      _createVNode(_component_a_button, {
                                        type: "link",
                                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(jumpToCompany)(detail_data.value.company_id))),
                                        style: {"white-space":"pre-wrap"}
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(detail_data.value.customer_name), 1)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["value"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_col, { span: 6 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_form_item, {
                                label: "Business Center ID",
                                name: "bussiness_center_id"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_WeEditableWarp, {
                                    value: detail_data.value.bussiness_center_id,
                                    edit: editMode.value
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_a_input, {
                                        value: _unref(detail_data_edit).bussiness_center_id,
                                        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_unref(detail_data_edit).bussiness_center_id) = $event))
                                      }, null, 8, ["value"])
                                    ]),
                                    _: 1
                                  }, 8, ["value", "edit"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_col, { span: 6 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_form_item, {
                                label: "主体区域",
                                name: "region_type"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_WeEditableWarp, {
                                    value: _unref(getValueById)(regions.value, _unref(detail_data_edit).region_type),
                                    edit: editMode.value
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_we_select, {
                                        value: _unref(detail_data_edit).region_type,
                                        "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_unref(detail_data_edit).region_type) = $event)),
                                        options: regions.value
                                      }, null, 8, ["value", "options"])
                                    ]),
                                    _: 1
                                  }, 8, ["value", "edit"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_col, { span: 6 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_form_item, {
                                label: "主体资质名称",
                                name: "company_name"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_WeEditableWarp, {
                                    value: detail_data.value.company_name,
                                    edit: editMode.value,
                                    copy: true
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_a_input, {
                                        value: _unref(detail_data_edit).company_name,
                                        "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_unref(detail_data_edit).company_name) = $event))
                                      }, null, 8, ["value"])
                                    ]),
                                    _: 1
                                  }, 8, ["value", "edit"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_col, { span: 6 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_form_item, {
                                label: "营业执照编码",
                                name: "company_code"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_WeEditableWarp, {
                                    value: detail_data.value.company_code,
                                    edit: editMode.value,
                                    copy: true
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_a_input, {
                                        value: _unref(detail_data_edit).company_code,
                                        "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_unref(detail_data_edit).company_code) = $event))
                                      }, null, 8, ["value"])
                                    ]),
                                    _: 1
                                  }, 8, ["value", "edit"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_col, { span: 6 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_form_item, {
                                label: "已上传文件",
                                name: "upload_file"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(WeOssUpload, {
                                    value: _unref(detail_data_edit).upload_file,
                                    "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_unref(detail_data_edit).upload_file) = $event)),
                                    accept: ".pdf, image/*",
                                    "pop-type": "blank",
                                    limit: 1,
                                    "edit-mode": editMode.value
                                  }, null, 8, ["value", "edit-mode"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_col, { span: 6 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_form_item, {
                                label: "申请账户数量",
                                name: "account_count"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_WeEditableWarp, {
                                    value: detail_data.value.account_count,
                                    edit: editMode.value
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_a_input_number, {
                                        value: _unref(detail_data_edit).account_count,
                                        "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_unref(detail_data_edit).account_count) = $event)),
                                        style: {"width":"100%"}
                                      }, null, 8, ["value"])
                                    ]),
                                    _: 1
                                  }, 8, ["value", "edit"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_col, { span: 6 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_form_item, {
                                label: "账户时区",
                                name: "account_timezone"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_WeEditableWarp, {
                                    value: detail_data.value.account_timezone,
                                    edit: editMode.value
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_we_select, {
                                        value: _unref(detail_data_edit).account_timezone,
                                        "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_unref(detail_data_edit).account_timezone) = $event)),
                                        options: "time_zone"
                                      }, null, 8, ["value"])
                                    ]),
                                    _: 1
                                  }, 8, ["value", "edit"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_col, { span: 6 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_form_item, {
                                label: "目标投放地区",
                                name: "delivery_area"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_WeEditableWarp, {
                                    value: detail_data.value.delivery_area,
                                    edit: editMode.value
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_a_input, {
                                        value: _unref(detail_data_edit).delivery_area,
                                        "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_unref(detail_data_edit).delivery_area) = $event))
                                      }, null, 8, ["value"])
                                    ]),
                                    _: 1
                                  }, 8, ["value", "edit"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_col, { span: 12 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_form_item, {
                                label: "Code",
                                name: "product_id"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_WeEditableWarp, {
                                    value: detail_data.value.rd_product_code,
                                    edit: editMode.value
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_we_select, {
                                        value: _unref(detail_data_edit).product_id,
                                        "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_unref(detail_data_edit).product_id) = $event)),
                                        options: product_list.value,
                                        onChange: handle_product_code_change
                                      }, null, 8, ["value", "options"])
                                    ]),
                                    _: 1
                                  }, 8, ["value", "edit"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_col, { span: 12 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_form_item, {
                                label: "规定账户名称",
                                name: "account_name"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_WeEditableWarp, {
                                    value: detail_data.value.account_name,
                                    edit: editMode.value
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_a_input, {
                                        value: _unref(detail_data_edit).account_name,
                                        "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((_unref(detail_data_edit).account_name) = $event))
                                      }, null, 8, ["value"])
                                    ]),
                                    _: 1
                                  }, 8, ["value", "edit"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_col, { span: 12 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_form_item, {
                                label: "产品/落地页/站点名称",
                                name: "app_url"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_WeEditableWarp, {
                                    value: detail_data.value.app_url,
                                    edit: !_unref(is_inner) && editMode.value,
                                    copy: true
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_a_input, {
                                        value: _unref(detail_data_edit).app_url,
                                        "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((_unref(detail_data_edit).app_url) = $event))
                                      }, null, 8, ["value"])
                                    ]),
                                    _: 1
                                  }, 8, ["value", "edit"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_col, { span: 12 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_form_item, {
                                label: "产品链接",
                                name: "download_url"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_WeEditableWarp, {
                                    value: detail_data.value.download_url,
                                    edit: editMode.value,
                                    copy: true
                                  }, {
                                    text: _withCtx(() => [
                                      _createVNode(_component_a_button, {
                                        type: "link",
                                        onClick: _cache[14] || (_cache[14] = ($event: any) => (_unref(downloadByUrl)(detail_data.value.download_url)))
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(detail_data.value.download_url), 1)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    default: _withCtx(() => [
                                      _createVNode(_component_a_input, {
                                        value: _unref(detail_data_edit).download_url,
                                        "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((_unref(detail_data_edit).download_url) = $event))
                                      }, null, 8, ["value"])
                                    ]),
                                    _: 1
                                  }, 8, ["value", "edit"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          (_unref(is_inner))
                            ? (_openBlock(), _createBlock(_component_a_col, {
                                key: 0,
                                span: 6
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_form_item, {
                                    label: "投放方式",
                                    name: "delivery_method"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_WeEditableWarp, {
                                        value: _unref(getTextFromValue)(_unref(get_ml_delivery_method), detail_data.value.delivery_method, 'id', 'name'),
                                        edit: editMode.value
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_we_select, {
                                            value: _unref(detail_data_edit).delivery_method,
                                            "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((_unref(detail_data_edit).delivery_method) = $event)),
                                            options: _unref(get_ml_delivery_method)
                                          }, null, 8, ["value", "options"])
                                        ]),
                                        _: 1
                                      }, 8, ["value", "edit"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          _createVNode(_component_a_col, { span: 6 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_form_item, {
                                label: "联系人邮箱",
                                name: "contact_email"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_WeEditableWarp, {
                                    value: detail_data.value.contact_email,
                                    edit: editMode.value
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_a_input, {
                                        value: _unref(detail_data_edit).contact_email,
                                        "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => ((_unref(detail_data_edit).contact_email) = $event))
                                      }, null, 8, ["value"])
                                    ]),
                                    _: 1
                                  }, 8, ["value", "edit"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_col, { span: 6 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_form_item, {
                                label: "提交人",
                                name: "rd_applicant_name"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_WeEditableWarp, {
                                    value: detail_data.value.rd_applicant_name,
                                    edit: false
                                  }, null, 8, ["value"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_col, { span: 12 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_form_item, {
                                label: "备注",
                                name: "note"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_WeEditableWarp, {
                                    value: detail_data.value.note,
                                    edit: editMode.value
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_a_input, {
                                        value: _unref(detail_data_edit).note,
                                        "onUpdate:value": _cache[18] || (_cache[18] = ($event: any) => ((_unref(detail_data_edit).note) = $event))
                                      }, null, 8, ["value"])
                                    ]),
                                    _: 1
                                  }, 8, ["value", "edit"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_unref(is_google))
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createVNode(_component_a_row, { gutter: 20 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_col, { span: 6 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_form_item, {
                                  label: "来源",
                                  name: "rd_source"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_WeEditableWarp, {
                                      value: detail_data.value.rd_source,
                                      edit: false
                                    }, null, 8, ["value"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_col, { span: 12 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_form_item, {
                                  label: "客户名称",
                                  name: "customer_name"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_WeEditableWarp, {
                                      value: detail_data.value.customer_name,
                                      edit: false
                                    }, {
                                      text: _withCtx(() => [
                                        _createVNode(_component_a_button, {
                                          type: "link",
                                          onClick: _cache[19] || (_cache[19] = ($event: any) => (_unref(jumpToCompany)(detail_data.value.company_id))),
                                          style: {"white-space":"pre-wrap"}
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(detail_data.value.customer_name), 1)
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }, 8, ["value"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_col, { span: 6 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_form_item, {
                                  label: "客户简称",
                                  name: "customer_name"
                                }, {
                                  default: _withCtx(() => [
                                    (detail_data.value.company_id)
                                      ? (_openBlock(), _createBlock(_component_WeEditableWarp, {
                                          key: 0,
                                          value: detail_data.value.company.short_name,
                                          edit: false
                                        }, null, 8, ["value"]))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(detail_data.value.products, (product, index) => {
                          return (_openBlock(), _createBlock(_component_a_row, {
                            gutter: 20,
                            type: "flex",
                            style: _normalizeStyle({
                'flex- wrap': 'wrap',
                'border-bottom': index === detail_data.value.products.length - 1 ? '' : '1px solid  rgba(0, 0, 0, 0.12)',
                'padding-bottom': index === detail_data.value.products.length - 1 ? 0 : '24px',
                'padding-top': index === 0 ? 0 : '24px',
              }),
                            key: product.id
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_col, { span: 12 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_form_item, {
                                    label: "产品/落地页/站点名称",
                                    name: "app_url"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_WeEditableWarp, {
                                        value: product.app_url,
                                        edit: !_unref(is_inner) && editMode.value,
                                        copy: true
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_a_input, {
                                            value: _unref(detail_data_edit).products[index].app_url,
                                            "onUpdate:value": ($event: any) => ((_unref(detail_data_edit).products[index].app_url) = $event)
                                          }, null, 8, ["value", "onUpdate:value"])
                                        ]),
                                        _: 2
                                      }, 1032, ["value", "edit"])
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_a_col, { span: 12 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_form_item, {
                                    label: "产品链接",
                                    name: "product_url"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_WeEditableWarp, {
                                        value: product.product_url,
                                        edit: editMode.value,
                                        copy: true
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_a_input, {
                                            value: _unref(detail_data_edit).products[index].product_url,
                                            "onUpdate:value": ($event: any) => ((_unref(detail_data_edit).products[index].product_url) = $event)
                                          }, null, 8, ["value", "onUpdate:value"])
                                        ]),
                                        _: 2
                                      }, 1032, ["value", "edit"])
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_a_col, { span: 12 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_form_item, {
                                    label: "Code",
                                    name: "product_id"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_WeEditableWarp, {
                                        value: detail_data.value.rd_product_code,
                                        edit: editMode.value
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_we_select, {
                                            value: _unref(detail_data_edit).product_id,
                                            "onUpdate:value": _cache[20] || (_cache[20] = ($event: any) => ((_unref(detail_data_edit).product_id) = $event)),
                                            options: product_list.value,
                                            onChange: handle_google_code_change
                                          }, null, 8, ["value", "options"])
                                        ]),
                                        _: 1
                                      }, 8, ["value", "edit"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_a_col, { span: 12 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_form_item, {
                                    label: "规定账户名称",
                                    name: "account_name"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_WeEditableWarp, {
                                        value: product.account_name,
                                        edit: editMode.value,
                                        copy: true
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_a_input, {
                                            value: _unref(detail_data_edit).products[index].account_name,
                                            "onUpdate:value": ($event: any) => ((_unref(detail_data_edit).products[index].account_name) = $event)
                                          }, null, 8, ["value", "onUpdate:value"])
                                        ]),
                                        _: 2
                                      }, 1032, ["value", "edit"])
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024),
                              (_unref(is_inner))
                                ? (_openBlock(), _createBlock(_component_a_col, {
                                    key: 0,
                                    span: 6
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_a_form_item, {
                                        label: "投放方式",
                                        name: "delivery_method"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_WeEditableWarp, {
                                            value: _unref(getTextFromValue)(_unref(get_ml_delivery_method), detail_data.value.delivery_method, 'id', 'name'),
                                            edit: editMode.value
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_we_select, {
                                                value: _unref(detail_data_edit).delivery_method,
                                                "onUpdate:value": _cache[21] || (_cache[21] = ($event: any) => ((_unref(detail_data_edit).delivery_method) = $event)),
                                                options: _unref(get_ml_delivery_method)
                                              }, null, 8, ["value", "options"])
                                            ]),
                                            _: 1
                                          }, 8, ["value", "edit"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              _createVNode(_component_a_col, { span: 6 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_form_item, {
                                    label: "开户数量",
                                    name: "account_count"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_WeEditableWarp, {
                                        value: product.account_count,
                                        edit: editMode.value
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_a_input_number, {
                                            value: _unref(detail_data_edit).products[index].account_count,
                                            "onUpdate:value": ($event: any) => ((_unref(detail_data_edit).products[index].account_count) = $event)
                                          }, null, 8, ["value", "onUpdate:value"])
                                        ]),
                                        _: 2
                                      }, 1032, ["value", "edit"])
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_a_col, { span: 6 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_form_item, {
                                    label: "账户时区",
                                    name: "account_timezone"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_WeEditableWarp, {
                                        value: product.account_timezone,
                                        edit: editMode.value
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_we_select, {
                                            value: _unref(detail_data_edit).products[index].account_timezone,
                                            "onUpdate:value": ($event: any) => ((_unref(detail_data_edit).products[index].account_timezone) = $event),
                                            options: "time_zone"
                                          }, null, 8, ["value", "onUpdate:value"])
                                        ]),
                                        _: 2
                                      }, 1032, ["value", "edit"])
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_a_col, { span: 6 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_form_item, {
                                    label: "首充金额(USD)",
                                    name: "apply_amount"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_WeEditableWarp, {
                                        value: product.apply_amount,
                                        edit: editMode.value
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_a_input, {
                                            value: _unref(detail_data_edit).products[index].apply_amount,
                                            "onUpdate:value": ($event: any) => ((_unref(detail_data_edit).products[index].apply_amount) = $event)
                                          }, null, 8, ["value", "onUpdate:value"])
                                        ]),
                                        _: 2
                                      }, 1032, ["value", "edit"])
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_a_col, { span: 6 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_form_item, {
                                    label: "首充链接",
                                    name: "customer_name"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_WeEditableWarp, {
                                        value: detail_data.value.rd_ugs_recharge_apply_name,
                                        edit: false
                                      }, {
                                        text: _withCtx(() => [
                                          (detail_data.value.rd_ugs_recharge_apply_name)
                                            ? (_openBlock(), _createBlock(_component_a_button, {
                                                key: 0,
                                                type: "link",
                                                onClick: _cache[22] || (_cache[22] = ($event: any) => (_unref(jumpToOpenAccountRechargeDetail)({ id: detail_data.value.ugs_recharge_apply_id }))),
                                                style: {"white-space":"pre-wrap"}
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(detail_data.value.rd_ugs_recharge_apply_name), 1)
                                                ]),
                                                _: 1
                                              }))
                                            : (_openBlock(), _createElementBlock("span", _hoisted_9, "无"))
                                        ]),
                                        _: 1
                                      }, 8, ["value"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_a_col, { span: 6 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_form_item, {
                                    label: "联系人邮箱",
                                    name: "contact_email"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_WeEditableWarp, {
                                        value: detail_data.value.contact_email,
                                        edit: editMode.value
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_a_input, {
                                            value: _unref(detail_data_edit).contact_email,
                                            "onUpdate:value": _cache[23] || (_cache[23] = ($event: any) => ((_unref(detail_data_edit).contact_email) = $event))
                                          }, null, 8, ["value"])
                                        ]),
                                        _: 1
                                      }, 8, ["value", "edit"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_a_col, { span: 6 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_form_item, {
                                    label: "提交人",
                                    name: "rd_applicant_name"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_WeEditableWarp, {
                                        value: detail_data.value.rd_applicant_name,
                                        edit: false
                                      }, null, 8, ["value"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_a_col, { span: 12 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_form_item, {
                                    label: "备注",
                                    name: "note"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_WeEditableWarp, {
                                        value: detail_data.value.note,
                                        edit: editMode.value
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_a_input, {
                                            value: _unref(detail_data_edit).note,
                                            "onUpdate:value": _cache[24] || (_cache[24] = ($event: any) => ((_unref(detail_data_edit).note) = $event))
                                          }, null, 8, ["value"])
                                        ]),
                                        _: 1
                                      }, 8, ["value", "edit"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 2
                          }, 1032, ["style"]))
                        }), 128))
                      ], 64))
                    : _createCommentVNode("", true),
                  (_unref(isGod))
                    ? (_openBlock(), _createBlock(_component_a_row, {
                        key: 2,
                        gutter: 20,
                        type: "flex",
                        style: {"flex-wrap":"wrap"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_col, { span: 6 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_form_item, {
                                label: "端口类型",
                                name: "port_type"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_WeEditableWarp, {
                                    value: detail_data.value.port_type,
                                    edit: editMode.value
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_a_select, {
                                        value: _unref(detail_data_edit).port_type,
                                        "onUpdate:value": _cache[25] || (_cache[25] = ($event: any) => ((_unref(detail_data_edit).port_type) = $event)),
                                        options: [
                      { text: 'webeye', value: 'webeye' },
                      { text: 'nonwebeye', value: 'nonwebeye' },
                    ]
                                      }, null, 8, ["value"])
                                    ]),
                                    _: 1
                                  }, 8, ["value", "edit"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["model"])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                (_unref(can_show_button))
                  ? (_openBlock(), _createElementBlock("span", _hoisted_13, [
                      _createVNode(_component_a_button, {
                        type: "primary",
                        onClick: _cache[26] || (_cache[26] = ($event: any) => (edit_accounts('add')))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_14
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_button, {
                        type: "primary",
                        onClick: _cache[27] || (_cache[27] = ($event: any) => (edit_accounts('edit')))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_15
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createVNode(_component_we_table, {
                onRegister: _unref(register),
                dataSource: _unref(account_list)
              }, {
                action: _withCtx(({ record }) => [
                  _withDirectives(_createVNode(_component_a_button, {
                    type: "link",
                    onClick: ($event: any) => (edit_account(record))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_16
                    ]),
                    _: 2
                  }, 1032, ["onClick"]), [
                    [_vShow, _unref(can_show_button)]
                  ]),
                  _withDirectives(_createVNode(_component_a_button, {
                    type: "link",
                    onClick: ($event: any) => (delete_account(record)),
                    danger: ""
                  }, {
                    default: _withCtx(() => [
                      _hoisted_17
                    ]),
                    _: 2
                  }, 1032, ["onClick"]), [
                    [_vShow, _unref(can_show_button)]
                  ])
                ]),
                _: 1
              }, 8, ["onRegister", "dataSource"])
            ]),
            (!_unref(isEmptyData)(detail_data.value.flow))
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  _createVNode(_component_FlowTimeLine, {
                    flow: detail_data.value.flow,
                    onOnUpdate: init_data,
                    onOnCatchFlag: catchFlowFlag
                  }, null, 8, ["flow"])
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 16, ["title"]))
}
}

})